"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var CarouselPicker = /*#__PURE__*/function () {
  function CarouselPicker(container) {
    _classCallCheck(this, CarouselPicker);

    this.container = container;
    this.activeSlide;
    this.init();
  }

  _createClass(CarouselPicker, [{
    key: "init",
    value: function init() {
      this.activeSlide = this.container.getElementsByClassName("is-active")[0];
      this.setLegend();
      this.listen();
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this = this;

      var pictures = _toConsumableArray(this.container.getElementsByClassName("picture-item"));

      pictures.forEach(function (picture) {
        picture.addEventListener("click", function (event) {
          if (picture.classList.contains('youtube')) {
            _this.setVideo(event.target);

            picture.classList.remove('youtube');
          } else {
            _this.switchPicture(event.target);
          }
        });
      });
    }
  }, {
    key: "switchPicture",
    value: function switchPicture(target) {
      var _this2 = this;

      this.activeSlide.classList.toggle("is-fading");
      var newSrc = target.dataset.image;
      setTimeout(function () {
        var oldSrc = _this2.activeSlide.dataset.image,
            newLegend = target.dataset.legend,
            oldLegend = _this2.activeSlide.dataset.legend,
            container = _this2.container.getElementsByClassName("is-active")[0];

        container.style.backgroundImage = "url(" + newSrc + ")";

        if (container.querySelector('.video-yt')) {
          container.querySelector('.video-yt').remove();
          container.style.backgroundColor = 'transparent';
          target.classList.add('youtube');
          target.dataset.video = _this2.activeSlide.dataset.video;
        }

        _this2.activeSlide.style.backgroundImage = newSrc;
        _this2.activeSlide.dataset.image = newSrc;
        _this2.activeSlide.dataset.legend = newLegend;
        target.style.backgroundImage = "url(" + oldSrc + ")";
        target.dataset.image = oldSrc;
        target.dataset.legend = oldLegend;

        _this2.setLegend();

        _this2.activeSlide.classList.toggle("is-fading");
      }, 100);
    }
  }, {
    key: "setLegend",
    value: function setLegend() {
      this.container.getElementsByClassName("js-legend")[0].innerHTML = this.activeSlide.dataset.legend;
    }
  }, {
    key: "setVideo",
    value: function setVideo(target) {
      var _this3 = this;

      this.activeSlide.classList.toggle("is-fading");
      var newSrc = target.dataset.image;
      setTimeout(function () {
        var oldSrc = _this3.activeSlide.dataset.image,
            newLegend = target.dataset.legend,
            oldLegend = _this3.activeSlide.dataset.legend,
            container = _this3.container.getElementsByClassName("is-active")[0],
            iframe = "\n            <div class=\"video-yt\">\n              <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/" + target.dataset.video + "?rel=0&autoplay=1\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n            </div>\n          ";

        _this3.activeSlide.style.backgroundImage = newSrc;
        _this3.activeSlide.dataset.image = newSrc;
        _this3.activeSlide.dataset.legend = newLegend;
        _this3.activeSlide.dataset.video = target.dataset.video;
        target.style.backgroundImage = "url(" + oldSrc + ")";
        target.dataset.image = oldSrc;
        target.dataset.legend = oldLegend;

        _this3.setLegend();

        _this3.activeSlide.classList.toggle("is-fading");

        container.style.backgroundImage = 'none';
        container.style.backgroundColor = 'black';
        container.innerHTML = iframe;
      }, 100);
    }
  }]);

  return CarouselPicker;
}();

document.addEventListener("DOMContentLoaded", function () {
  var containers = _toConsumableArray(document.getElementsByClassName("item-slider"));

  containers.forEach(function (container) {
    new CarouselPicker(container);
  });
});